
import { Vue, Component, Prop } from "vue-property-decorator";
import Terminos from "@/components/Common/Terminos.vue";

@Component({
  components: {
    Terminos
  }
})
export default class TerminosView extends Vue {
  private mounted() {}
}
